import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPDATE_PUBLISHER_WORKSPACE_ROLE: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updatePublisherWorkspaceRole($input: UpdatePublisherWorkspaceRoleInput!) {
    updatePublisherWorkspaceRole(input: $input) {
      userWorkspace {
        id
        role
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
